export class CaseDetails {
	caseNumber: string;
	courtType: string;
	caseType: string;
	judge: string;
	defendant: string;
	defendantFirstLast?: string;
	defendantSex?: string;
	charges?: string[];
	judicialCircuit?: string;
	county?: string;
	countyAllCaps?: string;

	constructor(init?: Partial<CaseDetails>) {
		this.caseNumber = init?.caseNumber ?? '';
		this.courtType = init?.courtType ?? '';
		this.caseType = init?.caseType ?? '';
		this.judge = init?.judge ?? '';
		this.defendant = init?.defendant ?? '';
		this.defendantFirstLast = init?.defendantFirstLast;
		this.defendantSex = init?.defendantSex;
		this.charges = init?.charges;
		this.judicialCircuit = init?.judicialCircuit;
		this.county = init?.county;
		this.countyAllCaps = init?.countyAllCaps;
	}

	static fromJson(json: any): CaseDetails {
		if (!json || typeof json !== 'object') return new CaseDetails();
		return new CaseDetails({
			caseNumber: json.caseNumber,
			courtType: json.courtType,
			caseType: json.caseType,
			judge: json.judge,
			defendant: json.defendant,
			defendantFirstLast: json.defendantFirstLast,
			defendantSex: json.defendantSex,
			charges: json.charges,
			judicialCircuit: json.judicialCircuit,
			county: json.county,
			countyAllCaps: json.countyAllCaps
		});
	}
}

export class CaseResponse {
	caseDetails: CaseDetails;

	constructor(init?: Partial<CaseResponse>) {
		this.caseDetails = init?.caseDetails ?? new CaseDetails();
	}

	static fromJson(json: any): CaseResponse {
		const details = CaseDetails.fromJson(json?.caseDetails);
		return new CaseResponse({ caseDetails: details });
	}

	isValid(): boolean {
		const d = this.caseDetails;
		return !!d && d.caseNumber?.trim().length > 0 && d.judge?.trim().length > 0 && d.defendant?.trim().length > 0;
	}
}



